function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionsSplashImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1080px",
    height: "490px",
    viewBox: "0 0 1080 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "TriangleOutL",
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.8)",
    style: {
      fillRule: "evenodd",
      stroke: "#b5b5b5",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b5b5b5",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    id: "path2418"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "TriangleInL",
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(-0.8)",
    style: {
      fillRule: "evenodd",
      stroke: "#b5b5b5",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b5b5b5",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    id: "path2409"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "TriangleInL-3",
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(-0.8)",
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#b5b5b5",
      strokeWidth: "1pt",
      strokeOpacity: 1
    },
    d: "M 5.77,0 -2.88,5 V -5 Z",
    id: "path2409-5"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "TriangleOutL-6",
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.8)",
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#b5b5b5",
      strokeWidth: "1pt",
      strokeOpacity: 1
    },
    d: "M 5.77,0 -2.88,5 V -5 Z",
    id: "path2418-2"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "TriangleInL-3-1",
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(-0.8)",
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#b5b5b5",
      strokeWidth: "1pt",
      strokeOpacity: 1
    },
    d: "M 5.77,0 -2.88,5 V -5 Z",
    id: "path2409-5-2"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    id: "TriangleOutL-6-7",
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.8)",
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#b5b5b5",
      strokeWidth: "1pt",
      strokeOpacity: 1
    },
    d: "M 5.77,0 -2.88,5 V -5 Z",
    id: "path2418-2-0"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e7e7e7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.94796,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    width: 1080,
    height: 490,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.74247,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 750.98328,
    cy: 245,
    r: 58.01767
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.74247,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 709.97296,
    cy: 105.65387,
    r: 58.01767
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.74247,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 709.97296,
    cy: 384.34613,
    r: 58.01767
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#TriangleInL)",
      markerEnd: "url(#TriangleOutL)"
    },
    d: "m 416.59158,243.75208 244.12346,-0.36871"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#b5b5b5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 2.74247,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stopColor: "#000000"
    },
    cx: 329.01672,
    cy: 245,
    r: 58.01767
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#TriangleInL-3)",
      markerEnd: "url(#TriangleOutL-6)"
    },
    d: "m 416.52028,281.56155 197.5758,65.15527"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#TriangleInL-3-1)",
      markerEnd: "url(#TriangleOutL-6-7)"
    },
    d: "m 417.15807,203.91813 197.5758,-65.15527"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsSplashImage);
export default __webpack_public_path__ + "static/media/TransactionsSplashImage.d5084066.svg";
export { ForwardRef as ReactComponent };